import { useId, useState } from 'react';
import { FilterBtnWithLine } from '../style';
import { conditionsArray } from '../../../../../../consts/conditions';

import React from 'react';
import { Button, Flex, Radio, rem, Text } from '@mantine/core';
import { IoGridOutline, IoTrash } from 'react-icons/io5';

const ConditionBtnWithLine = ({
  id,
  label,
  onSelectCondition,
  withActions,
  onClickGroup,
  disableGroup,
  disableDelete,
  onClickDelete
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const radioGroupName = useId();
  const rootId = id || 'grid-table-condition-btn';

  return (
    <FilterBtnWithLine id={id || 'grid-table-condition-btn-root'}>
      <div id={id ? `${rootId}-line` : 'grid-table-condition-btn-line'} className="line" />

      <Flex
        id={id ? `${rootId}-content` : 'grid-table-condition-btn-content'}
        justify="space-between"
        align="center"
        w="100%"
        h={rem(32)}
      >
        <Flex
          id={id ? `${rootId}-options` : 'grid-table-condition-btn-options'}
          gap={rem(10)}
          align="center"
          component="form"
          ml={rem(8)}
        >
          {conditionsArray.map((condition, idx) => (
            <Flex
              id={id ? `${rootId}-option-${idx}` : `grid-table-condition-option-${idx}`}
              align="center"
              key={idx}
              gap="4px"
              onClick={() => {
                onSelectCondition(condition.value);
                setIsOpen(false);
              }}
            >
              <Radio
                id={id ? `${rootId}-radio-${idx}` : `grid-table-condition-radio-${idx}`}
                name={radioGroupName}
                value={condition.value}
                checked={label === condition.value}
              />
              <Text fz="12px" c="dark.9">
                {condition.label}
              </Text>
            </Flex>
          ))}
        </Flex>

        {withActions && (
          <Flex gap={rem(8)} pos="sticky" right={0}>
            <Button
              id={id ? `${rootId}-group` : 'grid-table-condition-group'}
              size="sm"
              disabled={disableGroup}
              onClick={onClickGroup}
              variant="transparent"
              leftSection={<IoGridOutline />}
            >
              Make Group
            </Button>
            <Button
              id={id ? `${rootId}-delete` : 'grid-table-condition-delete'}
              size="sm"
              disabled={disableDelete}
              onClick={onClickDelete}
              variant="transparent"
              leftSection={<IoTrash />}
              c="red.6"
            >
              Delete
            </Button>
          </Flex>
        )}
      </Flex>
    </FilterBtnWithLine>
  );
};

export default ConditionBtnWithLine;
